module.exports = __webpack_public_path__ + "img/teamnote_logo.dc40453c.png";